"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseTablesPane = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var PaneWithTitle_1 = require("../placePage/PaneWithTitle");
var TablesGridSortProvider_1 = require("../sorting/sortProviders/TablesGridSortProvider");
var DatabaseDetails_1 = require("./DatabaseDetails");
var DatabaseTablesQueryGrid_1 = require("./DatabaseTablesQueryGrid");
function DatabaseTablesPane(props) {
    return (react_1.default.createElement(data_catalog_shared_1.VerticalFlexContainer, { fillFlexParent: true },
        react_1.default.createElement(DatabaseDetails_1.DatabaseDetails, { database: props.database }),
        react_1.default.createElement(PaneWithTitle_1.PaneWithTitle, { title: props.title },
            react_1.default.createElement(TablesGridSortProvider_1.TablesGridSortProvider, null, function (_a) {
                var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                return react_1.default.createElement(DatabaseTablesQueryGrid_1.DatabaseTablesQueryGrid, { databaseId: props.databaseId, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: orderBy, updateSortOrder: updateSortOrder });
            }))));
}
exports.DatabaseTablesPane = DatabaseTablesPane;
//# sourceMappingURL=DatabaseTablesPane.js.map